let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6asjW")).then(() => parcelRequire('86tgJ'));